import { render } from "./add-class.vue?vue&type=template&id=3002bea6&lang=html"
import script from "./add-class.vue?vue&type=script&lang=js"
export * from "./add-class.vue?vue&type=script&lang=js"

import "./add-class.vue?vue&type=style&index=0&id=3002bea6&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__